import { FC, useRef, useState } from "react";
import { StyleProp, StyleSheet, TextInput, View, ViewStyle } from "react-native";
import { useSelector } from "react-redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { SearchIcon, SearchIconButton } from "./impComponents";

export type tTopButtons = {
  onChangeText: (text: string) => void;
  rightIconShow: boolean;
  RightIcon: FC;
  RightIconSmall: FC;
  placeholder?: string;
  showSearch?: boolean;
  style?: StyleProp<ViewStyle>;
};

const PageTopButtons: FC<tTopButtons> = ({
  onChangeText: myOnChangeText,
  rightIconShow: myRightIconShow,
  RightIcon: MyRightIcon,
  RightIconSmall: MyRightIconSmall,
  placeholder: myPlaceholder,
  showSearch = true,
  style,
}) => {
  const isSmall = useSelector((state) => state.NavigationReducer.drawerType === "slide");
  const [sShowSearch, setShowSearch] = useState<boolean>(false);

  const aTextRef = useRef<TextInput | null>(null);

  const searchText = () => {
    setShowSearch(!sShowSearch);
    aTextRef.current?.focus();
  };

  return (
    <>
      {isSmall ? (
        <View style={[styles.gTopButtonsContainer, style]}>
          <View style={styles.gTopButtonsLeftContainer}>
            {showSearch && (
              <>
                <SearchIconButton SearchIconButton={{ onPress: () => searchText() }} />
                <TextInput
                  onChangeText={myOnChangeText}
                  placeholder={myPlaceholder ?? ""}
                  ref={aTextRef}
                  style={sShowSearch ? styles.gTopButtonsTextInput : styles.gDisplayOff}
                />
              </>
            )}
          </View>
          <View style={!myRightIconShow && styles.gDisplayOff}>
            <MyRightIconSmall />
          </View>
        </View>
      ) : (
        <View style={[styles.gTopButtonsContainerBig, style]}>
          <View style={styles.gTopButtonsLeftContainer}>
            {showSearch && (
              <>
                <SearchIcon style={styles.searchIcon} />
                <TextInput
                  onChangeText={myOnChangeText}
                  placeholder={myPlaceholder ?? ""}
                  style={styles.gTopButtonsTextInput}
                />
              </>
            )}
          </View>
          <View style={!myRightIconShow && styles.gDisplayOff}>
            <MyRightIcon />
          </View>
        </View>
      )}
    </>
  );
};

export default PageTopButtons;

const styles = StyleSheet.create({
  gDisplayOff: {
    display: "none",
  },
  gTopButtonsContainer: {
    alignSelf: "stretch",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  gTopButtonsContainerBig: {
    alignSelf: "stretch",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  gTopButtonsLeftContainer: {
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  gTopButtonsTextInput: {
    ...kFonts.bodySmallCenter,
    color: kColors.brandDark,
    height: 40,
    marginLeft: 2 * kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingBottom: 2,
    textTransform: "uppercase",
    width: "100%",
  },
  searchIcon: {
    height: 16,
    width: 16,
  },
});
